import { Box, Container, styled } from "@mui/material";

export const MainContainer = styled(Box)(() => ({
  height: "100%",
  display: "grid",
  gridTemplateRows: "auto auto 1fr",
  maxWidth: "false"
}));

export const ReportSelectorButtonBox = styled(Box)(() => ({
  display: "flex",
  marginLeft: "50px"
}));

export const ButtonBox = styled(Box)(() => ({
  display: "flex"
}));

export const ButtonBoxDetails = styled(Box)(({ theme }) => ({
  display: "flex",
  gridTemplateColumns: "40% 60%",
  gap: theme.spacing(1),
  alignItems: "center",
  justifyContent: "flex-end",
  marginTop: "20px"
}));